import React from 'react';
import classnames from 'classnames';
import { Button, Flex, Radio, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from '../Login.css';
const {
  t
} = I18N.ns('login.TwoFactorVerify');
export default function TwoFactorSelectForm(props) {
  const {
    twoFactorMethods,
    onChangeSelectedTwoFactorMethod,
    selectedMethod,
    twoFactorMethodVariant,
    twoFactorMethodClassName,
    twoFactorMethodRadioVariant,
    onRequest2FACode
  } = props;
  return /*#__PURE__*/React.createElement(Flex, {
    variant: "colL",
    className: S.identityContainer
  }, twoFactorMethods?.map(method => {
    return /*#__PURE__*/React.createElement(Radio, {
      containerClassName: classnames(twoFactorMethodClassName, S.radio),
      variant: twoFactorMethodRadioVariant,
      key: method.type,
      label: /*#__PURE__*/React.createElement(Flex, {
        variant: "colS"
      }, /*#__PURE__*/React.createElement(Text, {
        variant: "subtitle"
      }, method.name), /*#__PURE__*/React.createElement(Text, {
        variant: "caption"
      }, method.description)),
      onChange: onChangeSelectedTwoFactorMethod,
      on: true,
      value: selectedMethod?.type === method.type,
      eventData: method
    });
  }) || null, /*#__PURE__*/React.createElement(Button, {
    disabled: !selectedMethod,
    variant: twoFactorMethodVariant,
    className: twoFactorMethodClassName,
    onClick: onRequest2FACode,
    eventData: selectedMethod
  }, t('nextText')));
}